import api from "../../utils/api";

export const fetchProfile = async () => {
  const res = await api.get("/profile");
  return res.data.data;
};